/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : ruleEngineAction.js
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */

const ruleEngineActions = {
  get_rule_engine: {
    api_name: "/REM/rule-engine/rule-sets",
    https_method: "GET",
  },

  get_similar_tickets: {
    api_name: "/REM/rule-engine/tickets/getSimilarTicket",
    https_method: "POST",
  },

  update_rule_engine: {
    api_name: "/REM/rule-engine/rule-sets/:ruleSetId",
    https_method: "PUT",
  },

  add_rule_engine: {
    api_name: "/REM/rule-engine/rule-sets",
    https_method: "POST",
  },

  get_attached_legal_items: {
    api_name: "/REM/rule-engine/rule-sets/:ruleSetId/legal-links",
    https_method: "GET",
  },

  attach_legal_item: {
    api_name: "/REM/rule-engine/rule-sets/:ruleSetId/legal-links",
    https_method: "POST",
  },

  detach_legal_item: {
    api_name:
      "/REM/rule-engine/rule-sets/:ruleSetId/legal-links/:linkType/:targetId",
    https_method: "DELETE",
  },

  create_rule_workflow: {
    api_name: "/WFB/workflow",
    https_method: "POST",
  },

  atatch_workflow_to_rule_set: {
    api_name: "/REM/rule-engine/rule-sets/:ruleSetId/workflow",
    https_method: "POST",
  },

  view_rule_set_with_id: {
    api_name: "/REM/rule-engine/rule-sets/:ruleSetId",
    https_method: "GET",
  },

  get_workflow_for_rule_set: {
    api_name: "/REM/rule-engine/rule-sets/:ruleSetId/workflow",
    https_method: "GET",
  },

  update_rule_workflow: {
    api_name: "/WFB/workflow/:id",
    https_method: "PUT",
  },

  get_decision_matrix_intersections: {
    api_name: "/REM/rule-engine/decision-matrix/intersections",
    https_method: "GET",
  },

  get_decision_matrix_context: {
    api_name: "/REM/rule-engine/decision-matrix/context",
    https_method: "GET",
  },

  wfe_execution_start: {
    api_name: "/WFE/execution/start",
    https_method: "POST",
  },

  wfe_execution_node_complete: {
    api_name: "/WFE/execution/node/complete",
    https_method: "POST",
  },

  decision_matrix_get_context: {
    api_name: "/REM/rule-engine/decision-matrix/full-context",
    https_method: "GET",
  },
  re_create_ticket: {
    api_name: "/REM/rule-engine/tickets/create",
    https_method: "POST",
  },
    re_create_ticket_v1: {
    api_name: "/REM/rule-engine/tickets/re-create",
    https_method: "POST",
  },
};
export default ruleEngineActions;
